import { CardContent, Card, Typography, Button, Tabs, Tab, Box, Grid, } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";

import { makeStyles, useTheme } from "@mui/styles";
import Cards from "../../components/Cards";
import { environment, homeUrl, paymentBaseUrl, whatNext } from "../../constant";
import axios from "axios";
import Loader from "../../components/Loader";
import "../../pages/paymentPage.css";
import Header from "../../components/Header";
import Whatnext from "../../../src/components/Whatnext";
import NavBar from "../NavBar/NavBar";
import { Footer } from "../../components/Footer";
import { useLayoutEffect } from "react";
import DataServices from "../../components/DataServices";
import { useGlobalState } from "../../globalStyle";
// import Footer from "../../components/Footer";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value != index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box pt={4}>{children}</Box>
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& button": {
      minWidth: 50,
      margin: "0px 4px",
      fontFamily: 'Montserrat, sans-serif',
    },
  },
}));

const initialState = {
  clientCode: "",
  mobile: "",
  client_email: "",
  gst: "",
  first_name:""
};


const Products = ({ formattype }) => {

  const [width, height] = useWindowSize();
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [allPrducts, setAllProducts] = useState([]);
  const [allData, setAllData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [reqParams, setReqParams] = useState(initialState);

  const [formWidth, setFormWidth] = useState('');
  const [bottomSheetData, setIsBottomSheet] = useState("");
  const search = useLocation().search;
  const navigate = useNavigate();
  const leadSquaredBody = useGlobalState("leadSquaredDataVal")[0];

  const clientCodeRef = useRef(null);
  const mobileRef = useRef(null);
  const clientEmailRef = useRef(null);
  const productPlanIdRef = useRef(null);
  const productNameRef = useRef(null);
  const gst = useRef(null);
  const first_name = useRef(null);
  const last_name = useRef(null);
  const address = useRef(null);
  const city = useRef(null);
  const pincode = useRef(null);
  const state = useRef(null);
  const isLogo = useRef(false);
  const env = useRef(null);
  const isProductCode = useRef(null);
  let isBottomSheet = "false";
  let testingBox = "false";
  const secretPlans = useRef("false");
  const productUrl= useGlobalState("PRODUCTMAINURL")[0];
  const paymentBaseUrl= useGlobalState("PAYMENTBASEURL")[0];


  useEffect(() => {
    if (width > 1150) {
      setFormWidth('52%');
    } else {
      setFormWidth('100%')
    }
  }, [width])

  useEffect(() => {
    clientCodeRef.current = new URLSearchParams(search).get("clientCode");
    mobileRef.current = new URLSearchParams(search).get("mobile");
    clientEmailRef.current = new URLSearchParams(search).get("mailId");
    productPlanIdRef.current = new URLSearchParams(search).get("planCode");
    productNameRef.current = new URLSearchParams(search).get("plan");
    gst.current = new URLSearchParams(search).get("gst");
    first_name.current = new URLSearchParams(search).get("name");
    last_name.current = new URLSearchParams(search).get("last_name");
    address.current = new URLSearchParams(search).get("address");
    city.current = new URLSearchParams(search).get("city");
    pincode.current = new URLSearchParams(search).get("pincode");
    state.current = new URLSearchParams(search).get("state");
    isLogo.current = new URLSearchParams(search).get("logo");
    env.current = new URLSearchParams(search).get("env");
    isProductCode.current = new URLSearchParams(search).get("productCode");
    isBottomSheet = new URLSearchParams(search).get("hidebottomsheet");
    secretPlans.current = new URLSearchParams(search).get("splans");
    setIsBottomSheet(isBottomSheet)
    if (productPlanIdRef.current && paymentBaseUrl) {
      redirectPage(productPlanIdRef.current);

    }
  }, [search, isProductCode.current, secretPlans.current,paymentBaseUrl]);



  let isPaymentGateway = "";
  const redirectPage = async (productPlanCode) => {
    setIsLoading(true);
    try {
      const data = await DataServices.productData(productUrl);
      if (data) {
        const paymentConfig = await DataServices.paymentConfig(paymentBaseUrl);
        const isOneTimePurchase = data.products.some(product => {
          return product.child.some(child => {
            product.child.map(val => {
              if (val.code === productPlanCode) {
                isPaymentGateway = val.paymentGateway;
              }
            })
            return child.code === productPlanCode && !child.recurring;
          });
        });

        let currentPaymentGatewayType;
        let paymentGateway;
        if (isOneTimePurchase) {
          currentPaymentGatewayType = "onetime";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.onetime;
        } else {
          currentPaymentGatewayType = "subscription";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.subscription;
        }
        if (currentPaymentGatewayType && paymentGateway) {

          const shouldRenderBlock = (
            mobileRef.current !== null &&
            mobileRef.current !== "" &&
            mobileRef.current !== 10 &&
            mobileRef.current !== "null" &&
            clientEmailRef.current !== null &&
            clientEmailRef.current !== "" &&
            clientEmailRef.current !== "null"
          )
          const isMobileNotValid = mobileRef.current === null || mobileRef.current === "null" || mobileRef.current.toString().length !== 10 || mobileRef.current === "0000000000";
          if (shouldRenderBlock && !isMobileNotValid) {
            const req = {
              product_plan_id: productPlanIdRef.current || '',
              client_email: clientEmailRef.current || '',
              mobile: Number(mobileRef.current || '',),
              clientCode: clientCodeRef.current || mobileRef.current,
              gst: gst.current || "",
              first_name: first_name.current || '',
              address: address.current || '',
              city: city.current || '',
              pincode: pincode.current || '',
              state: state.current || '',
              logo: isLogo.current || false,
              productCode: isProductCode.current || false,
              formattype: formattype,
              ...leadSquaredBody,
              return_url: `${homeUrl}/payment/${currentPaymentGatewayType}/${paymentGateway.toLowerCase()}`,
            };
            navigate({
              pathname: '/details',
              search: `?${createSearchParams({ ...req, paymentMethod: currentPaymentGatewayType, paymentGateway: isPaymentGateway ? isPaymentGateway.toLowerCase() : paymentGateway.toLowerCase(), })}`,
            });
          } else {
            function sanitizeValue(value) {
              return value === null || value === "" || value === "null" || value === "0000000000" ? "" : value;
            }
            let clientCode = sanitizeValue(clientCodeRef.current || mobileRef.current);
            let mobile = sanitizeValue(mobileRef.current);
            let mailId = sanitizeValue(clientEmailRef.current);
            let planCode = sanitizeValue(productPlanIdRef.current);
            let firstName = sanitizeValue(first_name.current);
            let lastName = sanitizeValue(last_name.current);
            let userState = sanitizeValue(state.current);
            let userCity = sanitizeValue(city.current);
            let userAddress = sanitizeValue(address.current);
            let userPincode = sanitizeValue(pincode.current);
            let userEnv = sanitizeValue(env.current);
            let userGst = sanitizeValue(gst.current);
            if (isMobileNotValid) {
              mobile = ""; // Set mobile to empty string if not 10 digits
            }
            navigate({
              pathname: isPaymentGateway ? isPaymentGateway.toLowerCase() : paymentGateway.toLowerCase(),
              search: `?${createSearchParams({
                clientCode,
                mobile,
                mailId,
                planCode,
                first_name: firstName,
                last_name: lastName,
                state: userState,
                city: userCity,
                address: userAddress,
                pincode: userPincode,
                env: userEnv,
                logo: isLogo.current || false,
                productCode: isProductCode.current || "",
                paymentMethod: currentPaymentGatewayType,
                gst: userGst,
                formattype: formattype,
                ...leadSquaredBody,
                returnUrl: `${homeUrl}/${paymentGateway.toLowerCase()}/${currentPaymentGatewayType}`
              })}`,
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {
    if(productUrl){

      getProductData();
    }
  }, [value, allPrducts, filterData, productUrl]);

  // filter for the child and campaigns of the products
  let modifiedProductPlanId;
  const getProductData = async () => {
    if (isProductCode && isProductCode.current != null) {
      modifiedProductPlanId = isProductCode.current;
      allPrducts.map((val, i) => {
        if (isProductCode.current.includes("STOXCALLS")) {
          modifiedProductPlanId = modifiedProductPlanId.replace(/STOXCALLS/g, "PROTIPS");
        }
        if (modifiedProductPlanId && modifiedProductPlanId.toUpperCase().trim() === val.toUpperCase().replace(/ /g, '')) {
          setValue(i)
        }
      }
      )
    }
    try {
      const data = await DataServices.productData(productUrl);
      // const data = prodData;
      const isModified = modifiedProductPlanId !== undefined;

      let filteredProducts = data.products.filter(val => {
        const codeMatch = val.productCode.toLowerCase() === (modifiedProductPlanId?.toLowerCase() ?? allPrducts[value].toLowerCase());
        const productMatch = isModified ? codeMatch : val.product === allPrducts[value];
        return productMatch && (data.products.length > 0 && secretPlans.current === "true" ? codeMatch : true);
      });
      filteredProducts = filteredProducts.map(item => ({
        ...item,
        child: item.child.filter((childItem) => {
          if(!childItem.hasOwnProperty("visible") || childItem.visible == true || childItem.visible == "true")
            return childItem;
        })
      }));

      if (filteredProducts.length > 0) {
        if (secretPlans.current === "true") {
          setAllData(filteredProducts[0].campaigns || []);
        } else {
          setAllData(filteredProducts);
        }
      } else {
        setAllData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }

  }

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  useEffect(() => {
    testingBox = new URLSearchParams(search).get("testing");
    isBottomSheet = new URLSearchParams(search).get("hidebottomsheet");
    setIsBottomSheet(isBottomSheet)
  if(productUrl){  getAllProducts(testingBox);}
  }, [testingBox, isBottomSheet,productUrl]);

  const getAllProducts = async (testingBox) => {
    setIsLoading(true);
    try {
      const data = await DataServices.productData();
      // const data = prodData
      if (data.products.length > 0) {
        handleOnlyProducts(data, testingBox);
        setFilterData(data);
        setIsLoading(false);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  // filter for headers in Pricing Plans
  const handleOnlyProducts = (response, testingBox) => {
    if (testingBox === "true") {
      const allResult = response.products.map((res) => res.product);
      setAllProducts(allResult);
    } else {
      const filteredProducts = response.products.filter(product => product.product !== "TestingBox" && (!product.hasOwnProperty("visible") || product.visible === "true" || product.visible === true));
      const result = filteredProducts.map((res) => res.product);
      setAllProducts(result);
    }
  };


  const CustomTab = ({ label, ...props }) => {
    return (
      <Tab
        {...props}
        disableRipple
        className={classes.tab}
        component={() => (
          <Button
            style={{
              backgroundColor: value === props.index ? '#563EEC' : "#F7F5FE",
              color: value === props.index ? theme.palette.primary.white : theme.palette.primary.dark,
              height: "40px",
              fontSize: "14px",
              lineHeight: "24px",
              fontFamily: "montserrat",
              fontWeight: 500,
              border: "1px solid rgba(0, 0, 0, 0.2)",
              minWidth: "auto",
              textTransform: 'none',
              minHeight: "50px",
            }}
            className="product-tabs"
            variant={value === props.index ? "contained" : "outlined"}
            onClick={() => handleChange(null, props.index)}
          >
            {label}
          </Button>
        )}
      />
    );
  };
  if (mobileRef.current && clientEmailRef.current && productPlanIdRef.current) {
    return (
      <Loader />
    );
  }

  return (
    <div className="pr-card-wrapper">
      <div className="pr-card-container" style={{
        width: formWidth,
      }}>
        {
          loading && productPlanIdRef.current ?
            (
              <Loader />
            ) : (
              <>
                {formattype && <Header title="Get unbiased stock recommedations at Zero Brokerage to Trade Successfully" />}

                <Card>
                  <CardContent>
                    <div className={formattype === "custom" ? "product-main-card-padding" : ""}>
                      <div>
                        <h6 className="product-header"
                          style={{
                            textAlign: formattype === 'custom' ? 'center' : 'start',
                          }}>Pricing Plans</h6>
                      </div>
                      <div className="pr-tab-wrapper">
                        {
                          isProductCode.current ? null :
                            <Tabs
                              className={classes.tabs}
                              value={value}
                              TabIndicatorProps={{
                                style: { display: 'none' },
                              }}
                              variant="scrollable"
                              scrollButtons={false}
                              aria-label=" wrapped scrollable auto tabs example"
                            >
                              {
                                isProductCode.current && isProductCode.current && formattype === "custom" ? null :
                                  (allPrducts.map((val, i) => (
                                    <CustomTab key={i} label={val} index={i} />
                                  )))
                              }
                            </Tabs>
                        }
                        <TabPanel value={value} index={value}>
                          <Cards cardDetails={allData && allData} userData={reqParams} formattype={formattype} isBottomSheetEnabled={bottomSheetData} secretPlansData={secretPlans.current} />
                        </TabPanel>
                      </div>
                    </div>
                    {formattype === "custom" && <Whatnext steperData={whatNext} />}
                  </CardContent>
                </Card>
                {formattype && <Footer />}
              </>
            )
        }
      </div>
    </div>
    // </div>

  );
};

export default Products;
